module.exports = __webpack_public_path__ + "img/0D.38d814ea.png";